export const TagDiscount = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_5495)">
<path d="M18.2959 18.3232L8.20267 19.3472" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
<circle cx="13.5827" cy="23" r="1" stroke="currentColor" stroke-width="2"/>
<circle cx="12.4923" cy="14.6703" r="1" stroke="currentColor" stroke-width="2"/>
<path d="M14.0319 6.78241C14.4547 6.35955 15.0446 6.1481 15.6398 6.20603L23.3029 6.95188C24.2475 7.04382 24.9974 7.7869 25.0979 8.73057L25.9257 16.4994C25.9897 17.1004 25.7786 17.6981 25.3512 18.1255L14.0152 29.4614C13.2342 30.2425 11.9678 30.2425 11.1868 29.4614L2.68402 20.9587C1.90297 20.1776 1.90297 18.9113 2.68402 18.1303L14.0319 6.78241Z" stroke="currentColor" stroke-width="2"/>
<path d="M21.8319 10.2742L28.1061 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="20.5" cy="11.5" r="1.5" stroke="currentColor" stroke-width="2"/>
</g>
<defs>
<clipPath id="clip0_1_5495">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;
